import { unescape } from 'lodash';
import { RejectType } from '@uirouter/core';
import newrelicLib from '@adjust/dashboard-core/lib/newrelic/newrelic';

function MainController($scope, $state, $transitions, $window, $document, $location, User, PageTitle) {
  'ngInject';
  const vm = this;

  vm._handleChangeSuccess = _handleChangeSuccess;
  vm._checkRevision = _checkRevision;
  vm._trackPageView = _trackPageView;
  vm._handleRejectionRedirect = _handleRejectionRedirect;
  vm._handleChangeError = _handleChangeError;
  vm._handleContextMenu = _handleContextMenu;

  vm.$onInit = () => {
    vm.inMemoryRevision = null;
    vm.status = null;

    $transitions.onSuccess({}, vm._handleChangeSuccess);
    $transitions.onError({}, vm._handleChangeError);
    $document[0].addEventListener('contextmenu', vm._handleContextMenu);
  };

  /**
   * @param {Transition} tr
   * @private
   */
  function _handleChangeSuccess(tr) {
    $scope.$emit('global:clearLoading');

    // We are not tracking or updating the title for dynamic transitions because
    // they don't represent a full route change
    if (!tr.dynamic()) {
      vm._trackPageView(tr);
      PageTitle.requestTitle(tr).then(title => {
        $window.document.title = unescape(title);
      });
    }

    User.getRevision()
      .then(vm._checkRevision)
      .catch(() => {
        vm.status = 'loaded';
      });
  }

  /**
   * Checks if the revision matches the inMemoryRevision, and updates the
   * inMemoryRevision or reloads the window depending on the result.
   *
   * @private
   */
  function _checkRevision(revision) {
    if (revision && vm.inMemoryRevision && vm.inMemoryRevision !== revision) {
      vm.status = 'main-loading-white';
      $window.location.reload();
    } else {
      vm.inMemoryRevision = revision;
      vm.status = 'loaded';
    }
  }

  /**
   * Sends a pageView event to New Relic
   *
   * @param {Transition} tr
   * @private
   */
  function _trackPageView(tr) {
    __ENV__ === 'production' && newrelicLib.trackRouteChange(tr, $state.href);
  }

  /**
   * Set master loading state class when route is not resolved
   * and broadcast global error or redirect if path is defined
   *
   * @param {Transition} tr
   * @private
   */
  function _handleChangeError(tr) {
    const { type: rejectionType, detail: rejection } = tr.error();

    // Skip handling ignored or superseded transitions
    if (rejectionType === RejectType.IGNORED || rejectionType === RejectType.SUPERSEDED) {
      return;
    }

    if (rejection && rejection.redirect) {
      return vm._handleRejectionRedirect(rejection.redirect);
    }

    // Users coming from statisticsAccountSwitch should be redirected back
    // to the original page they were trying to access.
    if (tr.from().name === 'statisticsAccountSwitch' && rejection.status === 403) {
      return $state.go(tr.to().name, tr.params('to'), {
        location: 'replace',
      });
    }

    // Print the error to be able to debug edge cases with webpack chunking.
    console.log(rejection); // eslint-disable-line

    // Show error page without redirecting
    $state.go('errorPage', {}, { location: false });
  }

  /**
   * @param {RejectionRedirect} rejectionRedirect
   * @private
   */
  function _handleRejectionRedirect(rejectionRedirect) {
    const { reload = false, nextState, url } = rejectionRedirect;

    if (nextState) {
      $state.go(nextState);
    } else {
      $window.location.href = url;
      reload && $window.location.reload(true);
    }

    // Since the redirection was manual we need to reset the loading status
    vm.status = 'loaded';
    return;
  }

  /**
   * @param {Object} event Mouse event
   * @private
   */
  function _handleContextMenu(event) {
    const {target} = event;
    const selectionAttr = 'data-contextmenu-text-selection';

    if (!target.attributes[selectionAttr] && !target.parentElement.attributes[selectionAttr]) {
      return;
    }

    const selection = $window.getSelection();
    const range = $document[0].createRange();

    range.selectNode(target);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

export { MainController };
